import React, { useEffect, useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import messagesFinance from "../../../messages/finance";
import helperSpinner from "../../../helpers/spinner";
import httpService from "../../../services/httpServices/httpServices";
import helpersNumbers from "../../../helpers/numbers";
import TitleBar from "../../partials/content/TitleBar";

function Verify() {
  const [invoice, setInvoice] = useState(<></>);
  const [message, setMessage] = useState();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    verifyPayment();
  }, []);

  const verifyPayment = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const status = urlParams.get("Status");

    if (status != "OK") {
      setMessage({
        type_class: "alert alert-danger ",
        text: messagesFinance.PAYMENT_FAILED,
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }

    const authority = urlParams.get("Authority");
    const refNum = urlParams.get("ref_num");
    const resultSendRequestVerifyPayment = await sendRequestVerifyPayment(
      authority,
      refNum
    );
    if (!resultSendRequestVerifyPayment.success) {
      setMessage({
        type_class: "alert alert-danger ",
        text: messagesFinance.PAYMENT_FAILED,
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }
    setInvoice(
      <>
        <div className="alert alert-success text-dark d-flex align-items-center flex-column">
          <div>
            <span className="text-dark">پرداخت شما با موفقیت انجام شد.</span>
          </div>
          <div className="py-2">
            <table>
              <tr className="text-dark">
                <td>شماره فاکتور : </td>
                <td>
                  {helpersNumbers.toPersianNum(
                    resultSendRequestVerifyPayment.data.id
                  )}
                </td>
              </tr>
              <tr className="text-dark">
                <td>مبلغ پرداختی : </td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(
                        resultSendRequestVerifyPayment.data.amount
                      )
                    )}{" "}
                  </span>
                  <span>تومان</span>
                </td>
              </tr>
              <tr className="text-dark">
                <td>شماره پیگیری :</td>
                <td>{resultSendRequestVerifyPayment.data.reference}</td>
              </tr>
              <tr className="text-dark">
                <td>تاریخ درج :</td>
                <td>
                  {helpersNumbers.toPersianNum(
                    resultSendRequestVerifyPayment.data.created_at
                  )}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div className="text-center py-2 text-dark">
          شما بعد از <span id="second-counter">5</span> ثاینه از صفحه خارج
          خواهید شد
        </div>
      </>
    );

    setTimeout(function () {
      window.location.replace(
        `${process.env.REACT_APP_DOMAIN}/finance/invoices`
      );
    }, 5000);

    setInterval(decrementSeconds, 1000);
  };

  function decrementSeconds() {
    const secondCounterTag = document.querySelector("#second-counter");
    secondCounterTag.innerHTML = ` ${parseInt(secondCounterTag.innerText) - 1}`;
  }

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestVerifyPayment = async (authority, refNum) => {
    let result;
    let headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      result = await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/payment/verify",
        { ref_num: refNum, authority: authority },
        headersRequest
      );
    } catch (error) {
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }

    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return result.data;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="تاییده پرداخت  " />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {messageTag}
              {invoice}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Verify;
